export default __webpack_public_path__ + "static/media/title-remark.18d913d5.png";